import { Button, Form, Input, Select } from 'antd';
import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { ICategories } from '../../../types/TestType';
interface HrUsersHeaderProps {
  handleChange: (link: number) => void;
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  reset: () => void;
  categories: ICategories[];
}
const HrUsersHeader = (props: HrUsersHeaderProps) => {
  const [form] = Form.useForm();
  const { handleChange, handleSearch, reset, categories } = props;

  return (
    <>
      <div>
        <Form form={form} autoComplete="off" layout="vertical">
          <div
            style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1em' }}
          >
            <Form.Item
              style={{ width: '39%' }}
              label="Категория"
              name="category_id"
              initialValue={1}
            >
              <Select placeholder="Категория урока" onChange={handleChange}>
                <Select.Option value={1}>Все</Select.Option>
                {categories.map((item) => {
                  return (
                    <Select.Option value={item?.id} key={item?.id}>
                      {item.title}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item style={{ width: '51%' }} label="Поиск">
              <Input
                placeholder="Поиск..."
                prefixCls=""
                suffix={<SearchOutlined />}
                onChange={handleSearch}
              />
            </Form.Item>
            <Form.Item style={{ width: '10%' }}>
              <Button style={{ marginTop: '2em', width: '100%' }} onClick={reset}>
                Сбросить
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
};

export default HrUsersHeader;
